import { Download } from "lucide-react";
import { Reveal, MaskedLine, SectionTag } from "@/components/Reveal";
import Seo from "@/components/Seo";

const LegalPage = ({ tag, title, accent, intro, sections, testid, pdfUrl, seoTitle, seoDescription }) => (
    <div data-testid={testid}>
        <Seo title={seoTitle} description={seoDescription} />
        <section className="relative overflow-hidden bg-gradient-to-b from-mist to-white pb-16 pt-40 md:pt-48">
            <div className="absolute -right-40 top-0 h-[30rem] w-[30rem] rounded-full bg-brand/10 blur-[160px]" aria-hidden="true" />
            <div className="mx-auto max-w-4xl px-5 sm:px-8">
                <MaskedLine delay={0.1}><SectionTag>{tag}</SectionTag></MaskedLine>
                <h1 className="mt-6 font-display text-5xl font-black uppercase leading-[0.95] tracking-tighter sm:text-6xl">
                    <MaskedLine delay={0.25}>{title}</MaskedLine>
                    <MaskedLine delay={0.4}>
                        <span className="text-brand">{accent}</span>
                    </MaskedLine>
                </h1>
                <MaskedLine delay={0.55}>
                    <p className="mt-8 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">{intro}</p>
                </MaskedLine>
                {pdfUrl && (
                    <MaskedLine delay={0.7}>
                        <a
                            data-testid={`${testid}-download-button`}
                            href={pdfUrl}
                            download
                            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 font-bold text-white transition-[background-color,transform] duration-300 hover:bg-brand-hover hover:scale-105 active:scale-95"
                        >
                            <Download className="h-5 w-5" />
                            Télécharger les CGV en PDF
                        </a>
                    </MaskedLine>
                )}
            </div>
        </section>
        <section className="bg-white py-16 md:py-20">
            <div className="mx-auto max-w-4xl space-y-6 px-5 sm:px-8">
                {sections.map((s, i) => (
                    <Reveal key={s.title} delay={0.04 * i}>
                        <article
                            data-testid={`${testid}-section-${i + 1}`}
                            className="rounded-3xl border border-black/10 bg-white p-8 shadow-sm sm:p-10"
                        >
                            <h2 className="font-display text-2xl font-black uppercase tracking-tight text-brand">{s.title}</h2>
                            <div className="mt-4 space-y-4">
                                {s.paragraphs.map((p, j) => (
                                    <p key={j} className="text-sm leading-relaxed text-slate-600 sm:text-base">{p}</p>
                                ))}
                                {s.image && (
                                    <a href={s.image.href} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-section-${i + 1}-image-link`} className="inline-block pt-2">
                                        <img src={s.image.src} alt={s.image.alt} className="h-16 w-auto" />
                                    </a>
                                )}
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    </div>
);

export default LegalPage;
